// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.previos-session-message {
    font-size: 1.45rem;
    color: #0562fb;
    font-weight: bold;
    animation: fadeIn 1s ease-in-out forwards, waveEffect 3s ease-in-out infinite;
    animation-delay: 0.5s;
    text-align: center;
    margin-top: 1rem;
}

.previos-session-message span {
    display: inline-block;
    transform-origin: bottom;
    animation: waveEffect 2.5s ease-in-out;
    animation-delay: calc(0.1s * var(--i));
}

@keyframes waveEffect {

    0%,
    100% {
        transform: translateY(0);
    }

    50% {
        transform: translateY(-10px);
    }
}

@keyframes fadeIn {
    0% {
        opacity: 0;
    }

    100% {
        opacity: 1;
    }
}`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/sessionPage/components/SessionListing/components/previousSession/index.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,cAAc;IACd,iBAAiB;IACjB,6EAA6E;IAC7E,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,wBAAwB;IACxB,sCAAsC;IACtC,sCAAsC;AAC1C;;AAEA;;IAEI;;QAEI,wBAAwB;IAC5B;;IAEA;QACI,4BAA4B;IAChC;AACJ;;AAEA;IACI;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;AACJ","sourcesContent":[".previos-session-message {\n    font-size: 1.45rem;\n    color: #0562fb;\n    font-weight: bold;\n    animation: fadeIn 1s ease-in-out forwards, waveEffect 3s ease-in-out infinite;\n    animation-delay: 0.5s;\n    text-align: center;\n    margin-top: 1rem;\n}\n\n.previos-session-message span {\n    display: inline-block;\n    transform-origin: bottom;\n    animation: waveEffect 2.5s ease-in-out;\n    animation-delay: calc(0.1s * var(--i));\n}\n\n@keyframes waveEffect {\n\n    0%,\n    100% {\n        transform: translateY(0);\n    }\n\n    50% {\n        transform: translateY(-10px);\n    }\n}\n\n@keyframes fadeIn {\n    0% {\n        opacity: 0;\n    }\n\n    100% {\n        opacity: 1;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
